import { style } from "typestyle";
import { colors } from "styles/styles";

export const button = style({
  border: 0,
  background: "transparent",
  fontSize: "17px",
  fontWeight: 700,
  padding: "8px 30px",
  borderRadius: "40px",
  cursor: "pointer",
  textDecoration: "none"
});

export const linkButton = style({
  textDecoration: "none"
});

export const loadingWrapper = style({
  marginLeft: "0.5rem"
});

export const darkblue = style({
  color: colors.hooplaWhite,
  backgroundColor: colors.hooplaDarkBlue,
  boxShadow: "0 2px 2px " + colors.hooplaShadowColor
});

export const lightblue = style({
  color: colors.hooplaWhite,
  backgroundColor: colors.hooplaBlue,
  boxShadow: "0 2px 2px " + colors.hooplaShadowColor
});

export const green = style({
  backgroundColor: colors.green_00
});

export const outlined = style({
  border: `1px solid ${colors.hooplaBorderColor}`,
  backgroundColor: "#F8F8F8",
  color: colors.hooplaTextColor,
});

export const blueOutline = style({
  border: `1px solid ${colors.hooplaDarkBlue}`,
  backgroundColor: "transparent",
  color: colors.hooplaDarkBlue,
});
